import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Cell from '../Cell'

import styles from './styles.module.scss'

const CellHead = ({ className, ...rest }) => <Cell {...rest} className={classnames(styles.cellHead, className)} />

CellHead.defaultProps = {
  align: 'left',
  className: undefined,
}

CellHead.propTypes = {
  align: PropTypes.string,
  className: PropTypes.string,
  ...Cell.propTypes,
}

export default CellHead
